export enum Clients {
  sure = 'surepayroll',
  rp = 'runpayroll',
  pxgo = 'paychex',
  sunt = 'suntrust',
  tap = 'runpayroll',
  tru = 'truist',
}
